import { useState } from "react";
import { Mail, Phone, Globe } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Logo } from "./Logo";
import { CONTACT } from "@/data/content";

const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    body: "Fouzia Tarannum — Coaching & Mentoring collects only the details you share through the booking form (name, email, mobile number, age, gender, professional status, and your message) solely to schedule and conduct your strategy call and related mentoring communication. Your information is never sold or shared with third parties for marketing. Payment is processed securely by Razorpay; we never see or store your card details. To request deletion of your data, write to ftarannum08@gmail.com.",
  },
  terms: {
    title: "Terms & Conditions",
    body: "The Strategy Call (₹199) is a one-time mentoring conversation to discuss your goals, challenges, and next steps. Mentoring outcomes depend on your own participation and effort; no specific results are promised or guaranteed. Payments are processed via Razorpay and are subject to Razorpay's terms. Scheduling, rescheduling, and refund requests are handled on a case-by-case basis — contact ftarannum08@gmail.com for assistance.",
  },
};

export const Footer = () => {
  const [policy, setPolicy] = useState(null);

  return (
    <footer data-testid="footer-section" className="border-t border-peach/20 bg-cream py-16">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-muted">
            Helping youth move from confusion to clarity — envisioning the future they truly want, and walking with them, step by step, until they actually reach it. Not through motivation that fades, but through real, evidence-based transformation grounded in who they truly are. Because every young mind that finds its way doesn't just change one life — it changes everything that life touches.
          </p>
        </div>
        <div>
          <h3 className="font-heading text-xs font-bold uppercase tracking-[0.25em] text-peach-dark">Contact</h3>
          <ul className="mt-5 space-y-3.5 text-sm text-ink-muted">
            <li>
              <a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 transition-colors hover:text-peach-dark">
                <Phone size={15} className="text-peach-dark" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 transition-colors hover:text-peach-dark">
                <Mail size={15} className="text-peach-dark" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <span data-testid="footer-website" className="flex items-center gap-3">
                <Globe size={15} className="text-peach-dark" /> {CONTACT.website}
              </span>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-heading text-xs font-bold uppercase tracking-[0.25em] text-peach-dark">Legal</h3>
          <div className="mt-5 flex flex-col items-start gap-3.5">
            <button data-testid="footer-privacy-link" onClick={() => setPolicy("privacy")} className="text-sm text-ink-muted transition-colors hover:text-peach-dark">
              Privacy Policy
            </button>
            <button data-testid="footer-terms-link" onClick={() => setPolicy("terms")} className="text-sm text-ink-muted transition-colors hover:text-peach-dark">
              Terms &amp; Conditions
            </button>
          </div>
        </div>
      </div>
      <div className="mx-auto mt-14 max-w-6xl border-t border-peach/15 px-5 pt-7">
        <p className="text-center text-xs text-ink-subtle">© Fouzia Tarannum. All rights reserved.</p>
      </div>

      <Dialog open={!!policy} onOpenChange={() => setPolicy(null)}>
        <DialogContent data-testid="policy-dialog" className="max-w-lg rounded-3xl border-peach/25 bg-cream">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl font-extrabold text-ink">
              {policy && POLICIES[policy].title}
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm leading-relaxed text-ink-muted">{policy && POLICIES[policy].body}</p>
        </DialogContent>
      </Dialog>
    </footer>
  );
};
